import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface PhanTo {
  name: string;
  api_token: string;
}

export interface PhanToInfo {
  errors: unknown;
  listPhanTo: PhanTo;
  isAuthenticated: boolean;
}

@Module
export default class PhanToModule extends VuexModule implements PhanToInfo {
  errors = {};
  listPhanTo = {} as PhanTo;
  listLinhVucDieuTra = {};
  listCuocDieuTra = {};
  listDanhMucChiTieu = {};
  phanToDetail = {};
  isAuthenticated = !!JwtService.getToken();

  get getListPhanTo() {
    return this.listPhanTo;
  }

  get getListLinhVucDieuTra() {
    return this.listLinhVucDieuTra;
  }

  get getListCuocDieuTra() {
    return this.listCuocDieuTra;
  }

  get getListDanhMucChiTieu() {
    return this.listDanhMucChiTieu;
  }

  get getPhanToDetail() {
    return this.phanToDetail;
  }

  @Mutation
  [Mutations.PHAN_TO_LIST_DATA](listPhanTo) {
    this.listPhanTo = listPhanTo;
  }

  @Mutation
  [Mutations.LINH_VUC_DIEU_TRA_LIST_DROPDOWN_DATA](listLinhVucDieuTra) {
    this.listLinhVucDieuTra = listLinhVucDieuTra;
  }

  @Mutation
  [Mutations.CUOC_DIEU_TRA_LIST_DROPDOWN_DATA](listCuocDieuTra) {
    this.listCuocDieuTra = listCuocDieuTra;
  }

  @Mutation
  [Mutations.DANH_MUC_CHI_TIEU_LIST_DROPDOWN_DATA](listDanhMucChiTieu) {
    this.listDanhMucChiTieu = listDanhMucChiTieu;
  }

  @Mutation
  [Mutations.PHAN_TO_DETAIL_DATA](phanToDetail) {
    this.phanToDetail = phanToDetail;
  }

  @Action
  [Actions.PHAN_TO_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/gis/dmphanto", payload)
        .then((data) => {
          this.context.commit(Mutations.PHAN_TO_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.PHAN_TO_DETAIL](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(
        `/gis/dmphanto/${payload.maLinhVucDieuTra}-${payload.maCuocDieuTra}-${payload.maChiTieu}-${payload.maPhanTo}/detail`,
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.PHAN_TO_DETAIL_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.PHAN_TO_UPSERT](payload) {
    const pathEdit = payload.get("id")
      ? `/${payload.get("MaLinhvucDieuTra")}-${payload.get(
          "MaCuocDieutra"
        )}-${payload.get("MaChitieu")}-${payload.get("MaPhanto")}`
      : "";

    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(`gis/dmphanto/upsert${pathEdit}`, payload)
        .then((data) => {
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.PHAN_TO_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(
        `/gis/dmphanto/${payload.MaLinhvucDieuTra}-${payload.MaCuocDieutra}-${payload.MaChitieu}-${payload.MaPhanto}/delete`
      )
        .then((data) => {
          this.context.commit(Mutations.REPORT_KTXHS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.LINH_VUC_DIEU_TRA_LIST_DROPDOWN]() {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/gis/dmphanto/showLinhvucdieutra")
        .then((data) => {
          this.context.commit(
            Mutations.LINH_VUC_DIEU_TRA_LIST_DROPDOWN_DATA,
            data
          );
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.CUOC_DIEU_TRA_LIST_DROPDOWN](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(
        `/gis/dmphanto/showCuocdieutra/${payload.maLinhVucDieuTra}`
      )
        .then((data) => {
          this.context.commit(Mutations.CUOC_DIEU_TRA_LIST_DROPDOWN_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.DANH_MUC_CHI_TIEU_LIST_DROPDOWN](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post(
        `/gis/dmphanto/showChitieu/${payload.maCuocDieuTra}`
      )
        .then((data) => {
          this.context.commit(
            Mutations.DANH_MUC_CHI_TIEU_LIST_DROPDOWN_DATA,
            data
          );
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  //   @Action
  //   [Actions.REPORT_KTXHT_UPDATE_STATUS](payload) {
  //     if (JwtService.getToken()) {
  //       ApiService.setHeader();
  //       return ApiService.post(
  //         `/report_ktxh/${payload.id}/update-status`,
  //         payload
  //       )
  //         .then((data) => {
  //           this.context.commit(Mutations.REPORT_KTXHS_LIST_DATA, data);
  //           this.context.commit(Mutations.SET_ERROR, {});
  //         })
  //         .catch(({ response }) => {
  //           this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
  //         });
  //     }
  //   }
}
